import React from 'react';

const Thead = () => {

    return (
        <thead>
            <tr>
                <th className="th-black text-center">Funcionários</th>
                <th className="th-black text-center">Permitido apontar horas no projeto</th>
                <th className="th-black text-center">Permitido apontar horas fora do horário comercial</th>
            </tr>
        </thead>
    )
}

export default Thead;